<template>
  <div class="header-box">
    <div class="site-top">
      <div class="container g-clearfix">
        <ul class="left-top-menu">
          <li>
            <span class="js-page-wodedingdan" slot="title"
            >您好！欢迎来到顾家家居！</span
            >
          </li>
          <!-- <li>
            <router-link class="js-page-wodedingdan" slot="title" to="/home">首页</router-link>
          </li> -->
          <li v-if="!login">
            <router-link to="/login">登录</router-link>
          </li>
          <li v-if="!login" class="divider"></li>
          <li v-if="!login">
            <router-link to="/register?type=register">注册</router-link>
          </li>
          <li v-else @click="_loginOut">退出登陆</li>
          <li v-if="!login" @click="undesignlogin">设计圈</li>
          <li v-if="login" @click="designlogin">设计圈</li>
        </ul>
        <ul class="top-menu">
          <!-- <li>
            <div @click="linkTo({path:'/user'})" slot="title">会员中心</div>
          </li> -->
          <li>
            <div
              @click="linkTo({ path: '/cart' })"
              slot="title"
              class="header-cart"
            >
              <img src="/static/images/cart-home.png" alt="" class="cart-img" />
              购物车
              <span class="cart-num">
                <i class="num" :class="{ no: cartCount <= 0 }">{{
                    cartCount
                  }}</i>
              </span>
            </div>
          </li>
          <li class="divider"></li>
          <li>
            <div @click="linkTo({ path: '/user/orderList' })" slot="title">
              订单中心
            </div>
          </li>
          <li>
            <div
              @click="Jump('https://www.kukahome.com/serverCoop/HelpCenter')"
              slot="title"
            >
              帮助中心
            </div>
          </li>
          <li>
            <div @click="Jump('https://gw.kukahome.com/website')" slot="title">
              官方网站
            </div>
          </li>
          <!-- <li class="divider"></li>
					<li>
					<div @click="linkTo({path:'/user/rxOrderList',query:{type:'rx'}})" slot="title" >我的预约单</div>
          </li>-->
        </ul>
      </div>
    </div>
    <div>
      <header class="w">
        <div class="w-box">
          <div class="nav-logo" @click="$router.push({ path: '/home' })">
            <img :src="logoSrc" alt="无" />
          </div>
          <div class="right-box">
            <div class="search-wrap">
              <div class="nav-list">
                <img
                  src="/static/images/search.png"
                  alt=""
                  class="search-img"
                />
                <el-input
                  placeholder="输入商品名称..."
                  v-model="goods_name"
                  :minlength="1"
                  :maxlength="400"
                  @keydown.enter.native="handleIconClick"
                ></el-input>
                <!-- <div class="btn" @click="handleIconClick">搜索</div> -->
              </div>
            </div>
            <!--  <div class="nav-aside" ref="aside" :class="{fixed:st}">
              <div class="user pr">
                <div class="userinfo" @click="linkTo({path:'/user'})">个人中心</div>
                <div class="nav-user-wrapper pa" v-if="login">
                  <div class="nav-user-list">
                    <ul>
                      <li class="nav-user-avatar">
                        <div>
                          <span
                            class="avatar"
                            :style="{backgroundImage:'url('+userInfo.memberInfo.avatar+')'}"
                          ></span>
                        </div>
                        <p class="name">{{userInfo.memberInfo.username}}</p>
                      </li>
                      <li v-for="v in link_list">
                        <router-link :to="v.path">{{v.name}}</router-link>
                      </li>
                      <li>
                        <a href="javascript:;" @click="_loginOut">退出</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="shop pr" ref="positionMsg">
                <router-link to="/cart"></router-link>
                <span class="cart-num">
                  <i class="num" :class="{no:cartCount <= 0}">{{cartCount}}</i>
                </span>
              </div>
            </div> -->
          </div>
        </div>
      </header>
      <div v-if="isNav">
        <slot name="nav">
          <Nav
            :st="st"
            :cateList="cateList"
            @change="changeGoods"
            @selCate="selCate"
            :data="navConfig"
          ></Nav>
        </slot>
      </div>
    </div>
    <el-dialog
      title="填写邮箱"
      :visible.sync="designModalVisible"
      width="450px"
    >
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item
          prop="email"
          label="邮箱"
          :rules="[
            { required: true, message: '请输入邮箱地址', trigger: 'blur' },
            {
              type: 'email',
              message: '请输入正确的邮箱地址',
              trigger: ['blur', 'change'],
            },
          ]"
        >
          <el-input v-model="form.email"></el-input>
          <span style="color: red">邮箱只能联系管理员更改，请仔细确认。</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="designModalVisible = false"
        >取 消</el-button
        >
        <el-button size="small" type="danger" @click="updateEmail(form)"
        >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import YButton from "/components/YButton";
import { mapMutations, mapState } from "vuex";
import {
  getCartList,
  cartDel,
  getQuickSearch,
  getParamByTempName,
  getCartCount,
} from "/api/goods";
import {
  getCateList,
  userInfo,
  getLogo,
  getDesignTags,
  updateDesignEmail,
} from "/api";
import { setStore, getStore } from "/utils/storage";
import "element-ui/lib/theme-chalk/index.css";
import { find } from "lodash";
import Nav from "./nav";
export default {
  props: {
    showCate: {
      type: Boolean,
      default: true,
    },
    isNav: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      logoSrc: "", //logo 地址
      user: {},
      // 查询数据库的商品
      st: false,
      goods_name: "",
      searchResults: [],
      timeout: null,
      cateList: [], // 商品别表表单
      navConfig: {},
      form: {
        email: "",
      },
      link_list: [
        { path: "/user/orderList", name: "我的订单" },
        { path: "/user/rxorderList?type=rx", name: "我的预约单" },
        { path: "/user/information", name: "账号资料" },
        { path: "/user/addressList", name: "收货地址" },
        { path: "/user/support", name: "售后服务" },
        { path: "/user/coupon", name: "我的优惠" },
      ],
      designModalVisible: false,
    };
  },
  computed: {
    ...mapState(["login", "userInfo", "cartCount"]),
  },
  methods: {
    ...mapMutations([
      "LOG_OUT",
      "RECORD_USERINFO",
      "UPDATE_BREADCRUMB",
      "UPDATE_CARTCOUNT",
    ]),

    /**
     * 获取logo
     */
    _getLogo() {
      getLogo()
        .then(({ data }) => {
          this.logoSrc = data.logo;
          console.log("log", data.logo);
        })
        .catch(() => {});
    },

    linkTo(path) {
      if (this.login) {
        this.$router.push(path);
        return;
      }
      this.$router.push({ path: "/login" });
    },
    Jump(url) {
      window.open(url);
    },
    toCart() {
      window.open(window.location.origin + "#/cart");
    },
    handleIconClick(ev) {
      if (this.$route.path === "/goods") {
        this.$router.push({
          path: "/refreshgoods",
          query: {
            keywords: this.goods_name,
          },
        });
        return;
      }
      this.$router.push({
        path: "/goods",
        query: {
          keywords: this.goods_name,
        },
      });
    },
    changeGoods(params) {
      this.UPDATE_BREADCRUMB([]);
      if (params === -1) {
        this.$router.push({
          path: "/refreshgoods",
        });
        return;
      }
      if (params === -2) {
        this.$router.push({
          path: "/store",
        });
        return;
      }
      if (params.linkPage === "goods") {
        window.open(
          "//" + window.location.host + "/#/goodsDetails?itemId=" + params.id
        );
        return;
      }
      if (params.linkPage === "store") {
        window.open("//" + window.location.host + "/#/store?id=" + params.id);
      }
    },
    // 退出登录
    _loginOut() {
      localStorage.clear();
      this.LOG_OUT(false);
      this.$router.push({ path: "/login" });
      // window.location.href = '/'
    },
    openProduct(itemId) {
      window.open(
        "//" + window.location.host + "/#/goodsDetails?itemId=" + itemId
      );
    },
    _getCateList() {
      getCateList().then(({ data }) => {
        const list = data.filter(item => item.is_show === 1)

        this.cateList = list;
      });
    },
    _getUserInfo() {
      userInfo()
        .then(({ data }) => {
          this.RECORD_USERINFO(data);
        })
        .catch((_) => {});
    },
    _getCartCount() {
      const params = { shop_type: "distributor" };
      getCartCount(params).then(({ data }) =>
        this.UPDATE_CARTCOUNT(data.item_count)
      );
    },
    selCate(position, item, parentItem, grandChild) {
      console.log("selCate", this.$route, this.$router);
      let needLink = false;
      this.$route.path === "/home" && (needLink = true);
      if (position === 1) {
        this.UPDATE_BREADCRUMB([item]);
        needLink && this.$router.push({ path: "goods" });
        return;
      }
      if (position === 2) {
        this.UPDATE_BREADCRUMB([parentItem, item]);
        needLink && this.$router.push({ path: "goods" });
        return;
      }
      if (position === 3) {
        this.UPDATE_BREADCRUMB([parentItem, item, grandChild]);
        needLink && this.$router.push({ path: "goods" });
        return;
      }
    },
    _getParamByTemplate() {
      const params = {
        template_name: "pc",
        version: "v1.0.1",
        page_name: "index",
      };
      getParamByTempName(params)
        .then(({ data }) => {
          this.navConfig = data.config.find((v) => v.name === "nav").data;
          this.loading = false;
        })
        .catch(() => {
          this.error = true;
        });
    },
    designlogin() {
      getDesignTags().then(({ data }) => {
        if (data.code == 3000) {
          this.designModalVisible = true;
        } else if (data.code == 2000) {
          window.open(
            "https://www.kujiale.com/pub/site/design-zone/gujia/designs"
          );
        } else if (data.code == "0000") {
          window.open(
            `https://www.kujiale.com/v/auth?accesstoken=${data.token}&dest=14`
          );
        }
      });
    },
    undesignlogin() {
      window.open("https://www.kujiale.com/pub/site/design-zone/gujia/designs");
    },
    updateEmail(formData) {
      updateDesignEmail(formData).then(({ data }) => {
        if (data.code == 5000) {
          this.$message({
            message: "绑定用户失败",
            type: "error",
          });
        } else if (data.code == "0000") {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          window.open(
            `https://www.kujiale.com/v/auth?accesstoken=${data.token}&dest=14`
          );
        } else if (data.code == "6000") {
          this.$message({
            message: "绑定用户失败，该邮箱在设计圈没有账号",
            type: "error",
          });
        }
      });
      this.designModalVisible = false;
    },
    // 控制顶部
    navFixed() {
      if (
        this.$route.path === "/goods" ||
        this.$route.path === "/home" ||
        this.$route.path === "/goodsDetails" ||
        this.$route.path === "/thanks"
      ) {
        var st = document.documentElement.scrollTop || document.body.scrollTop;
        st >= 100 ? (this.st = true) : (this.st = false);
      } else {
        return;
      }
    },
  },
  mounted() {
    this._getUserInfo();
    this._getLogo();
    this.showCate && this._getCateList();
    this._getParamByTemplate();
    if (typeof this.$route.query.key !== undefined) {
      this.goods_name = this.$route.query.key;
    }
    !this.cartCount && this._getCartCount();
    this.navFixed();
    window.addEventListener("scroll", this.navFixed);
    window.addEventListener("resize", this.navFixed);
    if (this.$route.query.design === "true") {
      this.designlogin();
    }
  },
  components: {
    YButton,
    Nav,
  },
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
@import "../../assets/style/theme";
@import "../../assets/style/mixin";

.move_in_cart {
  animation: mymove 0.5s ease-in-out;
}

@keyframes mymove {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(0.8);
  }
  50% {
    transform: scale(1.2);
  }
  75% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}

@-moz-keyframes mymove {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(0.8);
  }
  50% {
    transform: scale(1.2);
  }
  75% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}

@-webkit-keyframes mymove {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(0.8);
  }
  50% {
    transform: scale(1.2);
  }
  75% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}

@-o-keyframes mymove {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(0.8);
  }
  50% {
    transform: scale(1.2);
  }
  75% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}

.header-box {
  background: #fff;
  width: 100%;
}

header {
  height: 134px;
  z-index: 30;
  position: relative;
  background: url("../../../static/images/header-bg.png") no-repeat center;
  background-size: cover;
  margin: 0;
  width: 100%;
  display: flex;
  justify-content: center;
}
.w-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  width: 1220px;
  .nav-logo {
    cursor: pointer;
    margin: 10px 10px 10px -15px;
    background-size: contain;
    width: 243px;
    height: auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  h1 {
    height: 100%;
    display: flex;
    align-items: center;
    > a {
      background: url("../../../static/images/global-logo-red@2x.png") no-repeat
      50%;
      background-size: cover;
      display: block;
      @include wh(50px, 40px);
      background-position: 0 0;
    }
    // text-indent: -9999px;
  }
  .nav-list {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 22px;
    height: 40px;
    width: 701px;
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
    .el-autocomplete {
      width: 405px;
    }
    .btn {
      background: #fa6450;
      color: #fff;
      padding: 0px 38px;
      border-radius: 0 4px 4px 0;
      margin-left: -22px;
      cursor: pointer;
      width: 125px;
      height: 100%;
      line-height: 40px;
      text-align: center;
    }
    a {
      width: 110px;
      color: #c8c8c8;
      display: block;
      font-size: 14px;
      padding: 0 25px;
      &:hover {
        color: #fff;
      }
    }
    a:nth-child(2) {
      margin-left: -10px;
    }
  }
  .nav-aside {
    position: relative;
    &:before {
      background: #333;
      background: hsla(0, 0%, 100%, 0.2);
      content: " ";
      @include wh(1px, 13px);
      overflow: hidden;
      display: flex;
      align-items: center;
      left: 0;
    }
    &.fixed {
      width: 262px;
      position: fixed;
      left: 50%;
      top: 19px;
      margin-left: 451px;
      margin-top: 0;
      z-index: 32;
      top: -40px;
      -webkit-transform: translate3d(0, 59px, 0);
      transform: translate3d(0, 59px, 0);
      -webkit-transition: -webkit-transform 0.3s
      cubic-bezier(0.165, 0.84, 0.44, 1);
      transition: transform 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
    }
  }

  .right-box {
    display: flex;
  }
  .nav-aside {
    display: flex;
    align-items: center;
  }
  // 用户
  .user {
    margin-left: 41px;
    width: 36px;
    &:hover {
      // a:before {
      //   background-position: -5px 0;
      // }
      .nav-user-wrapper {
        top: 18px;
        visibility: visible;
        opacity: 1;
        -webkit-transition: opacity 0.15s ease-out;
        transition: opacity 0.15s ease-out;
      }
    }
    > div {
      cursor: pointer;
      position: relative;
      @include wh(36px, 20px);
      &.userinfo {
        position: absolute;
        text-indent: -9999px;
        top: 0;
        bottom: 0;
        margin: auto;
        &:before {
          content: " ";
          position: absolute;
          left: 8px;
          top: 0;
          @include wh(20px);
          background: url(../../../static/images/account-icon.png) -155px 0;
          background-size: 240px 107px;
          transition: none;
        }
      }
    }
    li + li {
      text-align: center;
      position: relative;
      border-top: 1px solid #f5f5f5;
      line-height: 44px;
      height: 44px;
      color: #616161;
      font-size: 12px;
      &:hover {
        background: #fafafa;
      }
      a {
        display: block;
        color: #616161;
      }
    }
    .nav-user-avatar {
      > div {
        position: relative;
        margin: 0 auto 8px;
        @include wh(46px);
        text-align: center;
        // &:before {
        //   content: "";
        //   position: absolute;
        //   left: 0;
        //   right: 0;
        //   top: 0;
        //   bottom: 0;
        //   border-radius: 50%;
        //   box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .06);
        // }
        .avatar {
          border-radius: 50%;
          display: block;
          @include wh(100%);
          background-repeat: no-repeat;
          background-size: contain;
        }
      }
      .name {
        margin-bottom: 16px;
        font-size: 12px;
        line-height: 1.5;
        text-align: center;
        color: #757575;
      }
    }
    .nav-user-wrapper {
      width: 168px;
      transform: translate(-50%);
      left: 50%;
    }
    .nav-user-list {
      width: 168px;
      &:before {
        left: 50%;
      }
    }
  }
  .shop {
    position: relative;
    margin-left: 21px;
    width: 61px;
    z-index: 99;
    height: 20px;
    // &:hover {
    //   a:before {
    //     content: " ";
    //     background-position: 0 -22px;
    //   }
    // }
    .nav-user-wrapper.active {
      top: 18px;
      visibility: visible;
      opacity: 1;
      -webkit-transition: opacity 0.15s ease-out;
      transition: opacity 0.15s ease-out;
    }
    > a {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      display: block;
      right: 0;
      z-index: 1;
      &:before {
        display: block;
        @include wh(30px, 100%);
        content: " ";
        background: url(../../../static/images/account-icon.png) 0 -22px;
        background-size: 240px 107px;
        background-position: -150px -22px;
      }
    }
    .cart-num {
      position: relative;
      display: block;
      margin-left: 31px;
      margin-top: -1px;
      min-width: 30px;
      text-indent: 0;
      line-height: 20px;
      > i {
        background: #eb746b;
        background-image: -webkit-linear-gradient(#eb746b, #e25147);
        background-image: linear-gradient(#eb746b, #e25147);
        box-shadow: inset 0 0 1px hsla(0, 0%, 100%, 0.15),
        0 1px 2px hsla(0, 0%, 100%, 0.15);
        text-align: center;
        font-style: normal;
        display: inline-block;
        @include wh(20px);
        line-height: 20px;
        border-radius: 10px;
        color: #fff;
        font-size: 12px;
        &.no {
          background: #969696;
          background-image: -webkit-linear-gradient(#a4a4a4, #909090);
          background-image: linear-gradient(#a4a4a4, #909090);
          box-shadow: inset 0 0 1px #838383, 0 1px 2px #838383;
        }
      }
    }
    .nav-user-wrapper {
      right: 0;
      width: 360px;
      .nav-user-list {
        &:before {
          right: 34px;
        }
      }
    }
    .nav-user-list {
      padding: 0;
      width: 100%;
      .full {
        border-radius: 8px;
        overflow: hidden;
      }
      .nav-cart-items {
        max-height: 363px;
        overflow-x: hidden;
        overflow-y: auto;
      }
      .cart-item {
        height: 120px;
        width: 100%;
        overflow: hidden;
        border-top: 1px solid #f0f0f0;
        &:hover {
          background: #fcfcfc;
          .del {
            display: block;
          }
        }
      }
      li:first-child .cart-item:first-child {
        border-top: none;
        border-radius: 8px 8px 0 0;
        overflow: hidden;
      }
      .cart-item-inner {
        padding: 20px;
        position: relative;
      }
      .item-thumb {
        position: relative;
        float: left;
        width: 80px;
        height: 80px;
        border-radius: 3px;
        &:before {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          z-index: 2;
          border: 1px solid #f0f0f0;
          border: 0 solid transparent;
          box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.06);
          border-radius: 3px;
        }
        img {
          display: block;
          @include wh(80px, 80px);
          border-radius: 3px;
          overflow: hidden;
        }
      }
      .item-desc {
        margin-left: 98px;
        display: table;
        @include wh(205px, 80px);
        h4 {
          color: #000;
          width: 185px;
          overflow: hidden;
          word-break: keep-all;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 14px;
          line-height: 16px;
          margin-bottom: 10px;
        }
        .attrs span {
          position: relative;
          display: inline-block;
          margin-right: 20px;
          font-size: 14px;
          line-height: 14px;
          color: #999;
        }
        .attrs span:last-child {
          margin-right: 0;
        }
        h6 {
          color: #cacaca;
          font-size: 12px;
          line-height: 14px;
          margin-top: 20px;
          span {
            display: inline-block;
            font-weight: 700;
            color: #cacaca;
          }
          .price-icon,
          .price-num {
            color: #d44d44;
          }
          .price-num {
            margin-left: 5px;
            font-size: 14px;
          }
          .item-num {
            margin-left: 10px;
          }
        }
      }
      .cart-cell {
        display: table-cell;
        vertical-align: middle;
      }
      .del {
        display: none;
        overflow: hidden;
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .nav-cart-total {
      box-sizing: content-box;
      position: relative;
      padding: 20px;
      height: 40px;
      background: #fafafa;
      border-top: 1px solid #f0f0f0;
      border-radius: 0 0 8px 8px;
      box-shadow: inset 0 -1px 0 hsla(0, 0%, 100%, 0.5),
      0 -3px 8px rgba(0, 0, 0, 0.04);
      background: -webkit-linear-gradient(#fafafa, #f5f5f5);
      background: linear-gradient(#fafafa, #f5f5f5);
      p {
        margin-bottom: 4px;
        line-height: 16px;
        font-size: 12px;
        color: #c1c1c1;
      }
      h5 {
        line-height: 20px;
        font-size: 14px;
        color: #6f6f6f;
        span {
          font-size: 18px;
          color: #de4037;
          display: inline-block;
          font-weight: 700;
        }
        span:first-child {
          font-size: 12px;
          margin-right: 5px;
        }
      }
      h6 {
        position: absolute;
        right: 20px;
        top: 20px;
        width: 108px;
      }
    }
  }
}

@media (max-height: 780px) {
  .nav-cart-items {
    max-height: 423px !important;
  }
}

@media (max-height: 900px) {
  .nav-cart-items {
    max-height: 544px !important;
  }
}

@media (max-height: 1080px) {
  .nav-cart-items {
    max-height: 620px !important;
  }
}
// 用户信息弹出
.nav-user-wrapper {
  position: absolute;
  z-index: 30;
  padding-top: 18px;
  opacity: 0;
  visibility: hidden;
  top: -3000px;
  .nav-user-list {
    position: relative;
    padding-top: 20px;
    background: #fff;
    border: 1px solid #d6d6d6;
    border-color: rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
    z-index: 10;
    &:before {
      position: absolute;
      content: " ";
      background: url(../../../static/images/account-icon.png) no-repeat -49px -43px;
      background-size: 240px 107px;
      @include wh(20px, 8px);
      top: -8px;
      margin-left: -10px;
    }
  }
}

@media (min-width: 1px) {
  .nav-sub .nav-sub-wrapper:after {
    display: block;
  }
}

.cart-con {
  /*display: flex;*/
  text-align: center;
  position: relative;
  p {
    padding-top: 185px;
    color: #333333;
    font-size: 16px;
  }
}

.cart-con:before {
  position: absolute;
  content: " ";
  left: 50%;
  transform: translate(-50%, -70%);
  top: 50%;
  width: 76px;
  height: 62px;
  background: url("../../../static/images/cart-empty-new.png") no-repeat;
  background-size: cover;
}

.header-cart {
  position: relative;
  display: flex;
  align-items: center;

  .cart-img {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
  .cart-num {
    position: relative;
    display: block;
    margin-top: -17px;
    text-indent: 0;
    line-height: 16px;
    > i {
      background: #eb746b;
      background-image: -webkit-linear-gradient(#eb746b, #e25147);
      background-image: linear-gradient(#eb746b, #e25147);
      box-shadow: inset 0 0 1px hsla(0, 0%, 100%, 0.15),
      0 1px 2px hsla(0, 0%, 100%, 0.15);
      text-align: center;
      font-style: normal;
      display: inline-block;
      @include wh(16px);
      line-height: 16px;
      border-radius: 10px;
      color: #fff;
      font-size: 11px;
      &.no {
        background: #969696;
        background-image: -webkit-linear-gradient(#a4a4a4, #909090);
        background-image: linear-gradient(#a4a4a4, #909090);
        box-shadow: inset 0 0 1px #838383, 0 1px 2px #838383;
      }
    }
  }
}
</style>
<style lang="scss">
@import "../../assets/style/theme";
.fixed .cate-pop {
  top: 59px;
}
.cate-pop-div{
  position: absolute;
  top: 40px;
  left: 0;
}
.cate-pop {
  display: none;
  // background: #E60012;
  background: #ffffff;
  // border: 1px solid #eeeeee;
  border-top: 0;
  height: calc(100vh - 244px);
  width: 170px;
  overflow-y: scroll;
  z-index: 100;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
  padding-bottom: 20px;
  li {
    a {
      color: #222;
    }
    &:hover {
      // background: #f8f8f8;
      // .sub-cate {
      //   transition: all 0.3s ease;
      //   opacity: 1;
      //   display: block;
      // }

      a:hover {
        color: #e60012;
      }
    }
  }
  .sub-cate {
    transition: all 0.3s ease;

    // opacity: 0;
    // display: none;
    position: absolute;
    top: 0;
    left: 170px;
    background: #fff;
    width: 470px;
    min-height: 100%;
    padding-left: 40px;
    box-shadow: 8px 2px 10px -3px rgba(0, 0, 0, 0.2);
    .item {
      display: flex;
      flex-wrap: wrap;
      &:nth-child(1) {
        margin-top: 10px;
      }
      a {
        color: #333333;
        padding: 0 10px;
        font-weight: 600;
        font-size: 12px;
        &:hover {
          color: #e60012;
        }
      }
      span {
        color: #666;
        padding: 0 5px;
        &:hover {
          color: #e60012;
        }
      }
    }
  }
  > div {
    padding-bottom: 10px;
  }

  .sub-pannel {
    display: inline-block;
    width: 114px;
    font-size: 12px;
    vertical-align: top;
  }

  .sub-title {
    height: 44px;
    padding-top: 14px;
    padding-right: 10px;
    padding-bottom: 10px;
    margin-bottom: 10px;
    overflow: hidden;
    font-size: 14px;
    font-weight: bold;
    line-height: 44px;
    // border-bottom: 1px solid #dddddd;
  }

  .sub-list {
    line-height: 28px;
  }

  .site-all-product {
    display: block;
    width: 118px;
    margin-top: 20px;
    font-size: 12px;
    font-weight: bold;
    line-height: 22px;
    text-align: center;
    border: 1px solid #aaaaaa;
    border-radius: 20px;

    &:hover {
      color: #fff;
      background: #e60012;
      border-color: #e60012;
    }
  }
}
</style>
<style lang="scss">
@import "../../assets/style/theme";
.nav-list .search-img {
  width: 18px;
  height: 19px;
  padding-left: 24px;
  box-sizing: initial;
}
.nav-list .el-input {
  height: 100%;
}
.nav-list .el-input__inner {
  width: 400px;
  height: 100%;
  border: none;
}
.el-icon-search:before {
  color: #e60012;
}
</style>
<style scoped lang="scss">
$g-highlight: #fe313c;
$site-top-height: 40px;
.site-top {
  height: $site-top-height;
  font-size: 12px;
  line-height: $site-top-height;
  color: #fff;
  background-color: #000;
  .container {
    width: 1200px;
    margin: 0 auto;
    li {
      float: left;
      margin: 0 10px;
      cursor: pointer;
      &:nth-child(1) {
        padding-left: 0;
      }
      a {
        color: #fff;
        &:hover {
          color: $g-highlight;
        }
      }
      &.divider {
        width: 1px;
        height: 10px;
        padding: 0;
        margin-top: 15px;
        overflow: hidden;
        background-color: #cccccc;
      }
      &.red {
        color: $g-highlight;
      }
    }
  }
  .red {
    color: $g-highlight;
  }
  .left-top-menu {
    float: left;
  }
  .top-menu {
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// header.vue?70fe3a78